{
  "Editor": {
    "CameraTrack": {
      "Title": "Camera",
      "Hint": "One block per scene: who the video shows there. Click a block to change it, double click to start a new scene, drag the edge between two blocks to move the cut. Keys 1 to 9 pick a person, 0 everyone.",
      "Everyone": "Everyone",
      "Automatic": "Automatic",
      "Edited": "Edited by you",
      "CardLabel": "Camera of this scene",
      "Show": "Show",
      "Key": "Key",
      "SplitHere": "Split here",
      "BackToAuto": "Back to automatic",
      "Close": "Close"
    },
    "ClipLayout": {
      "Screen": "Screen",
      "ScreenShort": "Screen",
      "ScreenOf": "Screen of {{name}}",
      "ScreenFromTo": "{{screen}}, {{from}} to {{to}}",
      "ScreenFrom": "{{screen}}, from {{from}}",
      "ScreenAnd": "{{screen}} and {{name}}",
      "BrandKit": {
        "Title": "Video brand kit",
        "None": "None",
        "DefaultMark": "(default)",
        "Hint": "Frames, background and logo of the kit are applied to this clip."
      }
    },
    "VideoLayout": {
      "Label": "Video layout",
      "Auto": "Auto",
      "Grid": "Grid",
      "AutoHint": "Shows whoever is speaking and cuts to every turn of two seconds or more, with a look at everyone now and then. The first and last 15 seconds show everyone.",
      "GridHint": "Keep all participants visible throughout the video.",
      "AutoPending": "Speaker detection is still being prepared. The grid shows until it is ready.",
      "Tab": "Layout",
      "TabHint": "How the video is composed: scene style, transitions and the director",
      "Title": "Layout",
      "Close": "Close panel",
      "Reset": "Reset",
      "ResetTitle": "Back to the look of the brand kit, or to the default look",
      "Style": {
        "Title": "Scene style",
        "solo": "Speaker only",
        "soloHint": "The person speaking fills the frame.",
        "pip": "Picture in picture",
        "pipHint": "The person speaking fills the frame, the previous speaker appears in a small inset."
      },
      "Position": {
        "Title": "Position",
        "tl": "Top left",
        "tr": "Top right",
        "bl": "Bottom left",
        "br": "Bottom right"
      },
      "Transition": {
        "Title": "Transition",
        "cut": "Cut",
        "cutHint": "Scenes change with a hard cut.",
        "fade": "Fade",
        "fadeHint": "Scenes blend into each other."
      },
      "Director": {
        "Title": "Director",
        "calm": "Calm",
        "calmHint": "Looks at everyone less often and holds those looks longer.",
        "balanced": "Balanced",
        "balancedHint": "Looks at everyone at a natural pace.",
        "lively": "Lively",
        "livelyHint": "Looks at everyone more often, in short glimpses."
      },
      "OnlyInGrid": "Applies in Grid mode.",
      "Sections": {
        "Scenes": {
          "Title": "Scenes",
          "Description": "How the cuts and the picture-in-picture are made.",
          "SinglePerson": "One person: the whole recording shows them."
        },
        "BrandKit": {
          "Title": "Brand kit",
          "Description": "Save this look or reuse a saved one."
        },
        "Background": {
          "Title": "Background",
          "Description": "Colour, gradient or image behind the tiles."
        },
        "Tiles": {
          "Title": "Tiles",
          "Description": "Frame, spacing and arrangement of the participants' pictures. Drag the tiles on the preview."
        },
        "Names": {
          "Title": "Name labels",
          "Description": "Names shown on the tiles."
        },
        "Logo": {
          "Title": "Logo",
          "Description": "Upload a logo and drag it on the preview."
        }
      },
      "Look": {
        "Background": "Background",
        "Color": "Colour",
        "Gradient": "Gradient",
        "GradientTo": "Second colour",
        "Angle": "Angle",
        "BorderWidth": "Width",
        "Radius": "Corner radius",
        "Gap": "Tile gap",
        "GapHint": "0 shows the tiles edge to edge.",
        "Labels": "Show name labels",
        "LabelFont": "Font",
        "LabelColor": "Colour",
        "Logo": "Logo",
        "LogoNone": "None",
        "LogoHint": "Uses the logo of the brand kit.",
        "StagePadding": "Margin around the tiles",
        "LogoHeight": "Logo size",
        "LogoDragHint": "Drag the logo on the preview to place it.",
        "LogoReset": "Back to corner",
        "LogoFromKit": "Uses the logo of this video brand kit.",
        "LogoUpload": "Upload logo",
        "LogoReplace": "Replace logo",
        "LogoRemove": "Remove",
        "LogoAdminOnly": "Only administrators can upload a logo.",
        "BackgroundImage": "Background image",
        "BackgroundImageUse": "Use background image",
        "BackgroundImageMissing": "Upload a background image to the video brand kit.",
        "TilesAspect": "Keep aspect ratio",
        "TilesReset": "Reset arrangement for {{count}}",
        "TilesDragHint": "Drag the tiles on the preview to place and scale them.",
        "TilesAppliesTo": "Applies to every scene with {{count}} participants",
        "TilesAppliesToOne": "Applies to every scene with one participant",
        "TilesNotHere": "This scene has no movable tiles.",
        "Frame": "Tile frame",
        "FrameColor": "Frame colour",
        "GridNoCuts": "All cameras at once, no cuts.",
        "Colors": {
          "Black": "Black",
          "DarkGrey": "Dark grey",
          "White": "White",
          "Marine": "Hype blue",
          "Sapphire": "Dark blue",
          "DeepSky": "Sky blue",
          "Yellow": "Yellow",
          "LightBlue": "Light blue",
          "Custom": "Custom colour"
        }
      },
      "BrandKit": {
        "Title": "Video brand kit",
        "Custom": "Custom look",
        "Modified": "modified",
        "SaveAs": "Save as video brand kit",
        "Name": "Name",
        "NamePlaceholder": "e.g. New Heights",
        "Save": "Save",
        "Saving": "Saving...",
        "Cancel": "Cancel",
        "Saved": "Video brand kit saved.",
        "Logo": "Logo",
        "Background": "Background image",
        "Upload": "Upload",
        "Remove": "Remove",
        "Default": "Default kit for new clips",
        "DefaultMark": "(default)",
        "TooLarge": "The file is too large.",
        "Errors": {
          "forbidden": "Only administrators can save video brand kits.",
          "duplicate": "A video brand kit with this name already exists.",
          "invalid": "This kit could not be saved. Please check the name and the look.",
          "limit": "The limit of 50 video brand kits is reached. Delete one in the settings first.",
          "unknown": "That did not work. Please try again."
        }
      }
    },
    "SpeakerRename": {
      "Trigger": "Edit speakers",
      "Tooltip": "Rename the speakers in this transcript",
      "Title": "Rename speakers",
      "Hint": "Listen to each speaker's first sentence to identify them, then enter their real names.",
      "PlaySample": "Play sample",
      "StopSample": "Stop sample",
      "NewName": "New name",
      "Cancel": "Cancel",
      "Save": "Save",
      "Saved": "Speaker names updated.",
      "SaveFailed": "Could not save speaker names. Please try again.",
      "NoSpeakers": "No speakers detected in this transcript."
    },
    "CaptionStyle": {
      "Title": "Caption style",
      "Close": "Close panel",
      "StepChoose": "1. Choose a style",
      "StepCustomize": "2. Customize",
      "Customized": "(customized)",
      "OwnStyle": "Own style",
      "YourCompany": "Your company",
      "Templates": "Templates",
      "Default": "Default",
      "DefaultForLong": "Default for long-form videos",
      "DefaultForClip": "Default for promo clips",
      "DefaultForBoth": "Default for long-form videos and promo clips",
      "SampleText": "Made",
      "SampleWord": "simple",
      "Font": "Font",
      "Size": "Size",
      "Sizes": {
        "Small": "Small",
        "Medium": "Medium",
        "Large": "Large"
      },
      "TextColor": "Text color",
      "ActiveWord": "Active word",
      "Colors": {
        "White": "White",
        "Yellow": "Yellow",
        "Black": "Black",
        "LightBlue": "Light blue",
        "Blue": "Blue",
        "Gold": "Gold",
        "Red": "Red",
        "Green": "Green",
        "Custom": "Custom color",
        "None": "No highlight"
      },
      "Position": "Position",
      "Positions": {
        "Top": "Top",
        "Middle": "Middle",
        "Bottom": "Bottom"
      },
      "PositionHint": "You can also drag the captions in the player.",
      "Advanced": "Advanced settings",
      "Lines": "Single lines",
      "LinesHint": "Click a caption line in the player to style only that line.",
      "LinesCount": "{{count}} lines have their own style.",
      "TextGroup": "Text",
      "ExactSize": "Exact size",
      "Smaller": "Smaller",
      "Larger": "Larger",
      "Weight": "Weight",
      "FontStyle": "Style",
      "Bold": "Bold",
      "Italic": "Italic",
      "Normal": "Normal",
      "Weights": {
        "Light": "Light",
        "Regular": "Regular",
        "Medium": "Medium",
        "SemiBold": "Semibold",
        "Bold": "Bold",
        "ExtraBold": "Extra bold",
        "Black": "Black"
      },
      "Capitalization": "Capitalization",
      "Transforms": {
        "None": "As written",
        "Uppercase": "Uppercase",
        "Lowercase": "Lowercase",
        "Capitalize": "Capitalize words"
      },
      "LetterSpacing": "Letter spacing",
      "LineHeight": "Line height",
      "Outline": "Outline",
      "Color": "Color",
      "Width": "Width",
      "Shadow": "Shadow",
      "Blur": "Blur",
      "OffsetX": "Offset X",
      "OffsetY": "Offset Y",
      "Box": "Background box",
      "Padding": "Padding",
      "Radius": "Corner radius",
      "WordHighlight": "Word highlight",
      "HighlightSize": "Active word size",
      "WordBackground": "Active word box",
      "WordOutline": "Active word outline",
      "Alignment": "Alignment",
      "Aligns": {
        "Left": "Left",
        "Center": "Center",
        "Right": "Right"
      },
      "SaveAsCompany": "Save as company style",
      "Reset": "Reset",
      "ResetTitle": "Back to the selected style",
      "Name": "Name",
      "NamePlaceholder": "e.g. House style",
      "UseAsDefaultFor": "Use as default for",
      "NewLong": "New long-form videos",
      "NewClip": "New promo clips",
      "SaveHint": "Everyone in your company sees this style. Existing videos do not change.",
      "Save": "Save",
      "Saving": "Saving…",
      "Cancel": "Cancel",
      "MoreActions": "More actions for {{name}}",
      "Rename": "Rename",
      "Delete": "Delete",
      "ConfirmDelete": "Delete {{name}}? Videos that use it keep their look.",
      "UseForLong": "Default for new long-form videos",
      "UseForClip": "Default for new promo clips",
      "Overwrite": "Replace with current settings",
      "Errors": {
        "nameRequired": "Please enter a name.",
        "duplicate": "A style with this name already exists.",
        "forbidden": "Only company admins can change company styles.",
        "invalid": "This style could not be saved. Please check the settings.",
        "unknown": "That did not work. Please try again.",
        "conflict": "Someone else changed the default at the same time. Please try again."
      },
      "Line": {
        "Badge": "Line {{number}}",
        "EditingThisLine": "Changes here apply to this line only",
        "ApplyToAll": "Apply to all lines",
        "ApplyToAllTitle": "Make this line's settings the style of all lines",
        "ResetLine": "Reset line",
        "Done": "Done",
        "Own": "own",
        "Inherited": "global",
        "ResetField": "Back to the global style",
        "Fields": {
          "textColor": "Text color",
          "activeWordColor": "Active word color",
          "fontSize": "Font size",
          "fontFamily": "Font",
          "fontWeight": "Weight",
          "fontStyle": "Style",
          "backgroundBoxColor": "Box color",
          "outlineColor": "Outline color",
          "outlineWidth": "Outline width",
          "textTransform": "Capitalization",
          "letterSpacing": "Letter spacing",
          "lineHeight": "Line height",
          "horizontalAlign": "Alignment",
          "activeWordScale": "Active word size",
          "opacity": "Opacity"
        }
      },
      "Presets": {
        "hypecast": "Hypecast",
        "modern-bold": "Modern Bold",
        "tiktok-style": "Bold Pop",
        "box-highlight": "Box Highlight",
        "subtitle-classic": "Classic",
        "minimal-clean": "Minimal",
        "neon-glow": "Neon",
        "instagram-reels": "Reels",
        "youtube-shorts": "Shorts",
        "podcast-pro": "Podcast Pro"
      }
    }
  },
  "Breadcrumbs": {
    "podcasts": "Podcasts"
  },
  "Login": {
    "Email confirmation text": "Thank you for confirming your email address. Please login to continue.",
    "Login title": "Login",
    "Login": "Login",
    "Password": "Password",
    "Email": "Email",
    "The email address is required": "The email address is required",
    "The email address is not valid": "The email address is not valid",
    "The email address or password do not exist": "The email address or password do not exist",
    "This account has been blocked": "This account has been blocked",
    "An unknown error has occured": "An unknown error has occured",
    "Your organization is currently deactivated": "Your organization is currently deactivated",
    "Please confirm your email address": "Please confirm your email address",
    "Your password is required": "Your password is required",
    "Forgot password?": "Forgot password?",
    "Imprint": "Imprint",
    "Data protection": "Data protection",
    "Teaser headline": "HYPECAST<br> Your All-in-One Corporate Podcasting Solution",
    "Teaser subline": "Create and distribute your internal and external corporate podcasts - easy and safe! Manage your audio content, premium content, and subscribers in one tool. Create individual audiences and personalized, curated playlist for your audiences."
  },
  "Password reset": {
    "Reset password": "Reset password",
    "Change your password": "Change your password",
    "The email address is required": "The email address is required",
    "The email address is invalid": "The email address is invalid",
    "This email does not exist in our system": "This email does not exist in our system",
    "The email can have a maximum of 256 characters": "The email can have a maximum of 256 characters",
    "email send": "You will receive an email from us at the provided email address.<br> In the\nsaid\nemail, you will be provided with the necessary instructions on how to reset\nyour password.",
    "The password is required": "The password is required",
    "password length": "The new password must contain at least 8 characters, and represent a\ncombination of special characters, numbers, and upper and lowercase letters.",
    "password confirm": "Confirm new password",
    "new password confirm": "You need to confirm the new password",
    "passwords not match": "The passwords do not match",
    "new password": "Enter your new password to reset your current one",
    "Cancel": "Cancel",
    "Login": "Log in?",
    "Login Button": "Login",
    "Imprint": "Imprint",
    "Data protection": "Data protection"
  },
  "Episode transcript": {
    "Title": "Transcript",
    "Empty": "No transcript yet for this episode.",
    "Trigger": "Generate transcript",
    "Pending": "Transcription queued…",
    "Processing": "Transcribing audio. This may take a few minutes.",
    "Failed": "Transcription failed.",
    "ErrorDetails": "Details",
    "Retry": "Retry transcription",
    "Loading": "Loading transcript…",
    "LoadError": "Could not load transcript.",
    "UnknownSpeaker": "Speaker",
    "AutoScroll": "Auto-scroll",
    "AutoScrollOn": "Auto-scroll is on. Click to stop the transcript from following the audio",
    "AutoScrollOff": "Auto-scroll is off. Click to follow the audio again",
    "Copy": "Copy",
    "CopyTooltip": "Copy the transcript to your clipboard",
    "Copied": "Transcript copied to clipboard",
    "CopyFailed": "Could not copy transcript",
    "Download": "Download",
    "DownloadTooltip": "Download the transcript as a .txt file",
    "SpeakerRename": {
      "Trigger": "Edit speakers",
      "Tooltip": "Rename the speakers in this transcript",
      "Title": "Rename speakers",
      "Hint": "Listen to each speaker's first sentence to identify them, then enter their real names.",
      "PlaySample": "Play sample",
      "StopSample": "Stop sample",
      "NewName": "New name",
      "Cancel": "Cancel",
      "Save": "Save",
      "Saved": "Speaker names updated.",
      "SaveFailed": "Could not save speaker names. Please try again.",
      "NoSpeakers": "No speakers detected in this transcript."
    },
    "Edit": {
      "Trigger": "Correct",
      "Tooltip": "Correct words and speaker names in this transcript",
      "Save": "Save",
      "SaveWithCount": "Save ({{count}})",
      "Cancel": "Cancel",
      "Saved": "Transcript corrections saved.",
      "SaveFailed": "Could not save the corrections. Your changes are still here. Please try again.",
      "SaveIgnored": "The server did not apply the corrections. The API may be outdated. Please contact support.",
      "DiscardTitle": "Discard corrections?",
      "DiscardMessage": "You have unsaved corrections. Leaving edit mode discards them.",
      "PassageLabel": "Text of this passage",
      "SpeakerHint": "Edit each passage like normal text: fix words, remove fillers, rewrite a sentence. Words you do not touch keep their exact timing. Esc restores a passage. Renaming a speaker applies to all their passages."
    }
  },
  "Podcast form": {
    "Notifications": {
      "Heading": "Notifications about new episodes",
      "Description": "When a new episode of this podcast becomes visible, listeners who have access will be notified. Individual episodes can override this default.",
      "Toggle label": "Notify users when new episodes are published"
    }
  },
  "Podcast sample": {
    "Badge": "Sample",
    "Tooltip": "Example content to explore Hypecast. Delete it any time.",
    "Notice": "This is a sample podcast. Delete it when you no longer need it.",
    "Delete": "Delete podcast"
  },
  "Episode form": {
    "Notifications": {
      "Heading": "Notification override",
      "Description": "This podcast's default is {{podcastDefault}}. Override for this episode only if needed.",
      "Inherit": "Use podcast default ({{podcastDefault}})",
      "Force on": "Notify users, even if podcast default is off",
      "Force off": "Do not notify users, even if podcast default is on",
      "Yes": "notify",
      "No": "do not notify"
    },
    "Type": {
      "Description": "Please select the type of this episode: full, trailer, or bonus. The type cannot be changed after creation.",
      "Full": "Full",
      "Trailer": "Trailer",
      "Bonus": "Bonus",
      "Info": {
        "Full": "A full episode represents a standalone episode of this podcast.",
        "Trailer": "A trailer is a teaser for this podcast. It is shown with a play button in the podcast header instead of the episode list.",
        "Bonus": "A bonus represents extra content, for example an interview or behind-the-scenes material. It appears in the episode list with a bonus badge."
      },
      "Trailer exists warning": "This podcast already has a published trailer. You can create another one, but the apps always play the most recently published trailer."
    }
  },
  "TenantLifecycle": {
    "Trial": "You are using Hypecast in a trial.",
    "TrialDaysLeft": "Trial: {{days}} days left",
    "TrialOneDayLeft": "Trial: 1 day left",
    "TrialEndsToday": "Trial: ends today",
    "ReadOnly": "Your trial has ended. Your workspace is read-only; your listeners can keep listening until {{date}}. We will not charge you.",
    "ReadOnlyNoDate": "Your trial has ended. Your workspace is read-only. We will not charge you.",
    "Offline": "Your podcasts are offline. The workspace will be deleted on {{date}}.",
    "OfflineNoDate": "Your podcasts are offline.",
    "Activate": "Activate plan",
    "Dismiss": "Dismiss notice",
    "Contact": "Book a meeting",
    "ActivationUnavailable": "Activation is not available right now. Please try again later or write to support@hypecast.one.",
    "ActivationForbidden": "Only company admins of your workspace can activate the plan.",
    "Checkout": {
      "Title": "Activate plan",
      "Loading": "One moment, we are loading your options.",
      "Processing": "We are finishing the activation …",
      "StepPlan": "Step 1 of 2: Plan",
      "StepPayment": "Step 2 of 2: Payment",
      "PlanLegend": "Plan",
      "IntervalLegend": "Billing",
      "Monthly": "Monthly",
      "Yearly": "Yearly",
      "PerMonth": "{{price}} / month",
      "PerYear": "{{price}} / year",
      "NotAvailable": "Not available",
      "Rss": "Private RSS feed (Spotify/Apple)",
      "PlanOnly": "{{plan}}",
      "PlanWithRss": "{{plan}}, with private RSS feed",
      "Continue": "Continue",
      "Back": "Back",
      "Cancel": "Cancel",
      "Close": "Close",
      "Done": "Done",
      "SavedCard": "{{card}}, valid until {{expiry}}",
      "SavedCardNoExpiry": "{{card}}",
      "SavedSepa": "SEPA Direct Debit {{account}}",
      "SavedBankAccount": "Bank account {{account}}",
      "UseOtherMethod": "Use a different payment method",
      "UseSavedMethod": "Use saved payment method",
      "ChangePlan": "Change plan",
      "PaymentLoading": "Loading payment form …",
      "Submitting": "Activating …",
      "ChargeTrial": "Your trial runs until {{date}}. On {{date}} we will charge {{price}}, nothing before.",
      "ChargeToday": "We will charge {{price}} today.",
      "BilledFrom": "Billing starts on {{date}}",
      "BilledFromTrialEnd": "Billing starts when your trial ends",
      "BilledFromToday": "Billing starts today",
      "Scheduled": "Plan saved. Your trial continues until {{date}}, then {{plan}} starts automatically.",
      "ScheduledNoDate": "Plan saved. {{plan}} starts automatically after your trial.",
      "Activated": "Plan activated. Your workspace is fully unlocked again.",
      "PaymentFailed": "The payment did not go through.",
      "PaymentFailedHint": "You can pay the open invoice directly or use a different payment method.",
      "OpenInvoice": "Open invoice",
      "HandoffContact": "We set up the plan for your workspace together with you. Book a meeting with us.",
      "HandoffLink": "The activation continues on a separate page.",
      "Errors": {
        "WorkspaceGone": "This workspace is being deleted and can no longer be activated. Write to support@hypecast.one.",
        "SubscriptionEnded": "Your plan has already ended and cannot be activated here. Write to support@hypecast.one and we will help you.",
        "SetupIncomplete": "The card is not confirmed yet. Please enter it again.",
        "PriceUnavailable": "This combination cannot be booked right now. Please choose another one.",
        "StripeUnavailable": "The payment form could not be loaded. Please check your connection or allow stripe.com in your blocker and try again.",
        "RedirectFailed": "The payment method was not confirmed. Please try again or use a different card.",
        "CardRejected": "The card was not accepted. Please check the details or use a different card.",
        "PaymentMethodUnavailable": "The saved payment method cannot be used. Please enter a different one."
      }
    }
  },
  "AuthAccessDenied": {
    "Title": "No access to this workspace",
    "Text": "Your account does not belong to this workspace. Sign in with a different account or ask a company admin of the workspace to invite you.",
    "Details": "Details: {{description}}",
    "SwitchAccount": "Sign in with a different account"
  },
  "PlanLimit": {
    "Podcasts": "Your plan includes {{limit}} podcasts. To add more, upgrade your plan.",
    "PodcastsOne": "Your plan includes 1 podcast. To add more, upgrade your plan.",
    "PodcastsNoLimit": "Your plan does not include more podcasts. To add more, upgrade your plan.",
    "Seats": "Your plan includes {{limit}} creator seats. To add more, upgrade your plan.",
    "SeatsOne": "Your plan includes 1 creator seat. To add more, upgrade your plan.",
    "SeatsNoLimit": "Your plan does not include more creator seats. To add more, upgrade your plan."
  }
}
